/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */

import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logoImage from "../../assets/images/logo.webp";

function Header() {
  const { t, i18n } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const [isDesktopServicesOpen, setIsDesktopServicesOpen] = useState(false);

  const desktopDropdownRef = useRef(null);
  const navigate = useNavigate();

  /* =====================================================
     MOBİL MENÜ AÇ / KAPAT
  ===================================================== */

  const toggleMenu = () => {
    setIsMenuOpen((prev) => {
      const next = !prev;

      if (next) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        setIsMobileServicesOpen(false);
      }

      return next;
    });
  };

  /* =====================================================
     TÜM SAYFA LİNKLERİ
  ===================================================== */

  const handleLinkClick = (path) => {
    // Mobil servis menüsünü kapat
    setIsMobileServicesOpen(false);

    // Masaüstü servis menüsünü kapat
    setIsDesktopServicesOpen(false);

    // Mobil popup menüyü kapat
    setIsMenuOpen(false);

    // Scroll kilidini kaldır
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    // Sayfaya yönlendir
    navigate(path);

    // Sayfanın başına çık
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }, 0);
  };

  /* =====================================================
     MOBİL HİZMETLER MENÜSÜ
  ===================================================== */

  const toggleMobileServices = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsMobileServicesOpen((prev) => !prev);
  };

  /* =====================================================
     MASAÜSTÜ HİZMETLER MENÜSÜ
  ===================================================== */

  const toggleDesktopServices = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDesktopServicesOpen((prev) => !prev);
  };

  /* =====================================================
     MASAÜSTÜ DROPDOWN DIŞINA TIKLAMA
  ===================================================== */

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target)
      ) {
        setIsDesktopServicesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  /* =====================================================
     MOBİL MENÜ CLASS KONTROLÜ
  ===================================================== */

  useEffect(() => {
    const sideMenu = document.querySelector(".side-menu__block");

    const overlay = document.querySelector(".side-menu__block-overlay");

    if (sideMenu) {
      if (isMenuOpen) {
        sideMenu.classList.add("active");
      } else {
        sideMenu.classList.remove("active");
      }
    }

    if (overlay) {
      if (isMenuOpen) {
        overlay.classList.add("active");
      } else {
        overlay.classList.remove("active");
      }
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [isMenuOpen]);

  /* =====================================================
     DİL DEĞİŞTİRME
  ===================================================== */

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  /* =====================================================
     MOBİL SERVİS LİNKLERİ
  ===================================================== */

  const mobileServiceLinkStyle = {
    display: "block",
    width: "100%",
    padding: "11px 15px",
    color: "inherit",
    textDecoration: "none",
  };

  return (
    <>
      {/* ==================================================
          MOBİL POPUP MENÜ
      ================================================== */}

      <div className={`side-menu__block ${isMenuOpen ? "active" : ""}`}>
        {/* OVERLAY */}

        <div
          className={`side-menu__block-overlay custom-cursor__overlay ${
            isMenuOpen ? "active" : ""
          }`}
          onClick={toggleMenu}
        >
          <div className="cursor"></div>
          <div className="cursor-follower"></div>
        </div>

        {/* MOBİL MENÜ İÇERİĞİ */}

        <div className="side-menu__block-inner">
          {/* ÜST KISIM */}

          <div className="side-menu__top justify-content-between">
            <Link
              to="/"
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick("/");
              }}
            >
              <img
                src="/assets/images/logo-mobile.webp"
                width="135"
                alt="Web Center"
                loading="lazy"
              />
            </Link>

            <button
              type="button"
              className="side-menu__toggler side-menu__close-btn"
              onClick={toggleMenu}
              aria-label={t("Menüyü Kapat")}
            >
              <img
                src="/assets/images/icons/close-1-1.webp"
                alt=""
                loading="lazy"
              />
            </button>
          </div>

          {/* ==================================================
              MOBİL NAV
          ================================================== */}

          <nav className="mobile-nav__container">
            <ul className="navigation clearfix">
              {/* ANASAYFA */}

              <li>
                <Link
                  to="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick("/");
                  }}
                >
                  {t("Anasayfa")}
                </Link>
              </li>

              {/* HAKKIMIZDA */}

              <li>
                <Link
                  to="/about"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick("/about");
                  }}
                >
                  {t("Hakkımızda")}
                </Link>
              </li>

              {/* ==================================================
                  MOBİL HİZMETLERİMİZ
                  
                  ÖNEMLİ:
                  Bootstrap dropdown sınıfları burada YOK.
              ================================================== */}

              <li className="mobile-services-menu">
                <button
                  type="button"
                  onClick={toggleMobileServices}
                  aria-expanded={isMobileServicesOpen}
                  style={{
                    width: "100%",
                    border: "0",
                    outline: "none",
                    background: "transparent",
                    padding: "0px 0",
                    margin: 0,
                    color: "#fff",
                    textAlign: "left",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontFamily: "inherit",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  <span>{t("HİZMETLERİMİZ")}</span>

                  <i
                    className={
                      isMobileServicesOpen
                        ? "fa fa-angle-down"
                        : "fa fa-angle-right"
                    }
                    aria-hidden="true"
                  ></i>
                </button>

                {/* ALT MENÜ */}

                {isMobileServicesOpen && (
                  <ul
                    className="mobile-services-submenu"
                    style={{
                      display: "block",
                      position: "static",
                      visibility: "visible",
                      opacity: 1,
                      transform: "none",
                      width: "100%",
                      height: "auto",
                      margin: 0,
                      padding: "0 0 5px 15px",
                      listStyle: "none",
                      background: "transparent",
                      pointerEvents: "auto",
                      color: "#fff",
                    }}
                  >
                    {/* WEB TASARIM */}

                    <li>
                      <Link
                        to="/web-design"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleLinkClick("/web-design");
                        }}
                      >
                        {t("WEB TASARIM")}
                      </Link>
                    </li>

                    {/* E-TİCARET */}

                    <li>
                      <Link
                        to="/e-ticaret"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleLinkClick("/e-ticaret");
                        }}
                      >
                        {t("E-TİCARET")}
                      </Link>
                    </li>

                    {/* DOMAIN HOSTING */}

                    <li>
                      <Link
                        to="/domain-hosting"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleLinkClick("/domain-hosting");
                        }}
                      >
                        {t("DOMAIN & HOSTING")}
                      </Link>
                    </li>

                    {/* HOSTING */}

                    <li>
                      <Link
                        to="/hosting"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleLinkClick("/hosting");
                        }}
                      >
                        {t("HOSTING PAKETLERİ")}
                      </Link>
                    </li>

                    {/* SSL */}

                    <li>
                      <Link
                        to="/domain-ssl"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleLinkClick("/domain-ssl");
                        }}
                      >
                        {t("SSL SERTİFİKASI")}
                      </Link>
                    </li>

                    {/* KURUMSAL E-POSTA */}

                    <li>
                      <Link
                        to="/kurumsal-e-posta"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handleLinkClick("/kurumsal-e-posta");
                        }}
                      >
                        {t("KURUMSAL E-POSTA")}
                      </Link>
                    </li>

                    {/* SEO */}

                    <li>
                      <Link
                        to="/seo-optimizasyon"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handleLinkClick("/seo-optimizasyon");
                        }}
                      >
                        {t("SEO")}
                      </Link>
                    </li>

                    {/* LOGO */}

                    <li>
                      <Link
                        to="/logo-tasarimi"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handleLinkClick("/logo-tasarimi");
                        }}
                      >
                        {t("LOGO ÇALIŞMASI")}
                      </Link>
                    </li>

                    {/* İŞLETME PROFİLİ */}

                    <li>
                      <Link
                        to="/isletme-profili"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handleLinkClick("/isletme-profili");
                        }}
                      >
                        {t("İŞLETME PROFİLİ")}
                      </Link>
                    </li>

                    {/* GOOGLE MAPS */}

                    <li>
                      <Link
                        to="/google-harita-kaydi"
                        style={mobileServiceLinkStyle}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          handleLinkClick("/google-harita-kaydi");
                        }}
                      >
                        {t("GOOGLE HARİTA KAYDI")}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* PROJELER */}

              <li>
                <Link
                  to="/projects"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick("/projects");
                  }}
                >
                  {t("PROJELERİMİZ")}
                </Link>
              </li>

              {/* İLETİŞİM */}

              <li>
                <Link
                  to="/contact"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLinkClick("/contact");
                  }}
                >
                  {t("İLETİŞİM")}
                </Link>
              </li>
            </ul>
          </nav>

          <div className="side-menu__sep"></div>

          {/* ==================================================
              MOBİL İLETİŞİM
          ================================================== */}

          <div className="side-menu__content">
            <p>
              <a href="mailto:info@webcenter.com.tr">info@webcenter.com.tr</a>

              <br />

              <a href="tel:+905434052825">0543 405 2825</a>
            </p>

            <div className="side-menu__social">
              <a
                href="https://www.facebook.com/profile.php?id=61569515864445"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fab fa-facebook-f"></span>
              </a>

              <a
                href="https://www.instagram.com/webcenter.office/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fab fa-instagram"></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ==================================================
          DESKTOP HEADER
      ================================================== */}

      <header className="main-header header-style-twelev">
        {/* TOPBAR */}

        <div className="topbar-twelev">
          <div className="container">
            <div className="topbar-twelev__wrapper">
              <ul className="topbar-twelev__info">
                <li>
                  <span className="linoor-icon-three-email-1 justify-content-center"></span>

                  <a href="mailto:info@webcenter.com.tr">
                    info@webcenter.com.tr
                  </a>
                </li>
              </ul>

              <ul className="list-unstyled topbar-twelev__social">
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61569515864445"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fab fa-facebook-f"></span>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.instagram.com/webcenter.office/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="fab fa-instagram"></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* ==================================================
            ANA HEADER
        ================================================== */}

        <div className="header-style-twelev__main">
          {/* LOGO */}

          <div className="logo-box">
            <div className="logo">
              <Link
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  handleLinkClick("/");
                }}
              >
                <img
                  src="/assets/images/logo.webp"
                  width="135"
                  height="135"
                  alt="Web Center"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />
              </Link>
            </div>
          </div>

          <div className="nav-outer clearfix">
            {/* ==================================================
                MOBİL MENU BUTONU
            ================================================== */}

            <div
              className="mobile-nav-toggler"
              onClick={toggleMenu}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  toggleMenu();
                }
              }}
            >
              <span className="icon flaticon-menu-2"></span>

              <span className="txt">{t("Menu")}</span>
            </div>

            {/* ==================================================
                DESKTOP NAV
            ================================================== */}

            <nav className="main-menu navbar-expand-md navbar-light ms-auto">
              <div
                className="collapse navbar-collapse clearfix"
                id="navbarSupportedContent"
              >
                <ul className="navigation clearfix">
                  {/* ANASAYFA */}

                  <li>
                    <Link
                      to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick("/");
                      }}
                    >
                      {t("Anasayfa")}
                    </Link>
                  </li>

                  {/* HAKKIMIZDA */}

                  <li>
                    <Link
                      to="/about"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick("/about");
                      }}
                    >
                      {t("Hakkımızda")}
                    </Link>
                  </li>

                  {/* ==================================================
                      DESKTOP HİZMETLERİMİZ
                  ================================================== */}

                  <li className="dropdown" ref={desktopDropdownRef}>
                    <a href="#" onClick={toggleDesktopServices}>
                      {t("HİZMETLERİMİZ")}

                      <span
                        className={`dropdown-btn fa ${
                          isDesktopServicesOpen
                            ? "fa-angle-down"
                            : "fa-angle-right"
                        }`}
                      ></span>
                    </a>

                    <ul
                      className={`dropdown-menu ${
                        isDesktopServicesOpen ? "show" : ""
                      }`}
                      style={{
                        display: isDesktopServicesOpen ? "block" : undefined,
                      }}
                    >
                      <li>
                        <Link
                          to="/web-design"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick("/web-design");
                          }}
                        >
                          {t("WEB TASARIM")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/e-ticaret"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick("/e-ticaret");
                          }}
                        >
                          {t("E-TİCARET")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/domain-hosting"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/domain-hosting");
                          }}
                        >
                          {t("DOMAIN & HOSTING")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/hosting"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/hosting");
                          }}
                        >
                          {t("HOSTING PAKETLERİ")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/domain-ssl"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/domain-ssl");
                          }}
                        >
                          {t("SSL SERTİFİKASI")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/kurumsal-e-posta"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/kurumsal-e-posta");
                          }}
                        >
                          {t("KURUMSAL E-POSTA")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/seo-optimizasyon"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/seo-optimizasyon");
                          }}
                        >
                          {t("SEO")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/logo-tasarimi"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/logo-tasarimi");
                          }}
                        >
                          {t("LOGO ÇALIŞMASI")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/isletme-profili"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/isletme-profili");
                          }}
                        >
                          {t("İŞLETME PROFİLİ")}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/google-harita-kaydi"
                          onClick={(e) => {
                            e.preventDefault();

                            handleLinkClick("/google-harita-kaydi");
                          }}
                        >
                          {t("GOOGLE HARİTA KAYDI")}
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* PROJELER */}

                  <li>
                    <Link
                      to="/projects"
                      onClick={(e) => {
                        e.preventDefault();

                        handleLinkClick("/projects");
                      }}
                    >
                      {t("PROJELERİMİZ")}
                    </Link>
                  </li>

                  {/* İLETİŞİM */}

                  <li>
                    <Link
                      to="/contact"
                      onClick={(e) => {
                        e.preventDefault();

                        handleLinkClick("/contact");
                      }}
                    >
                      {t("İLETİŞİM")}
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>

            {/* ==================================================
                DİL + TELEFON
            ================================================== */}

            <div className="header-style-twelev__btn clearfix">
              <button
                type="button"
                onClick={() => changeLanguage("tr")}
                className="cart-toggler"
              >
                <span>TR</span>
              </button>

              <button
                type="button"
                onClick={() => changeLanguage("en")}
                className="cart-toggler"
              >
                <span>EN</span>
              </button>

              <a className="header-style-twelev__call" href="tel:+905434052825">
                <i className="flaticon-call"></i>
              </a>
            </div>

            {/* WHATSAPP */}

            <a
              href="https://wa.me/905434052825"
              className="thm-btn-twelev"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("HIZLI TEKLİF ALIN!")}
            </a>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
